var windows = $(window);
var sticky = $('.header-sticky');

windows.on('scroll', function() {
  var scroll = windows.scrollTop();
  if (scroll < 230) {
    sticky.removeClass('is-sticky');
  }else{
    sticky.addClass('is-sticky');
  }
});

$('.why_client_slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1199,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false
    }
  },{
    breakpoint: 991,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },{
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true
    }
  }]
});

$('.srvc_slider').slick({
  dots: false,
   arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true
    }
  }]
});

$(".lever_center_slider").slick({
  dots: true,
  infinite: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 790,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(".slider").slick({
  infinite: true,
  dots: false,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


function showcart(para) {
  if(para==1) {
    $(".drawer").show('slow');
    $(".drawer").css('right','0px');
  }
  if(para==2) {
    $(".drawer").hide();
    $(".drawer").css('right','-450px');
  }

  $(".mobilemenu").hide(); 
}

jQuery(document).ready(function(){
  $('.closetop').click( function(){ 
    $('#top-banner').fadeOut();
    localStorage.setItem('dialogShown', 1); 
  });

  $('.close_popup').click( function(){ 
    $('.product_pop_up_sec1').fadeOut();
  });

  $(".menu_div").click(function(){
    $(".toplmenu").hide();
    $(".toplmenu1").show();
    $(".mobilemenu").css('left','0px');
    $(".mobilemenu").fadeIn(500);
  });
  $(".menu_icn").click(function(){
    $(".toplmenu").show();
    $(".toplmenu1").hide();
    $(".mobilemenu").fadeOut(600);
  });
});

$(document).ready(function() {
  var dialogShown = localStorage.getItem('dialogShown')

  if (!dialogShown) {
    $('#top-banner').show();
  }
  else {
    $('#top-banner').hide();
  }
});

function showacc() {    
  $('.accountdiv').slideToggle('medium');  
} 

$(window).scroll(function() {        
  if($(window).scrollTop() < 60) {
    $(".banner--clone").removeClass('banner--stick'); 
    $(".accountdiv").css({'top':'auto'});
  } else {             
    $(".banner--clone").addClass('banner--stick');                      
    $(".accountdiv").css({'top':'59px'});
  }
});

function cpop() {    
  $('.cpopup').fadeIn();  
  $('.cpopup').css({'display': 'flex'});
  $('body').css({'overflow': 'hidden'});
}
function closep() {
  $('.cpopup').fadeOut();         
  $('body').css({'overflow': 'visible'});
}  

function totop() {
  $('html, body').animate({
    scrollTop: $("#bodyid").offset().top
  }, 500);
}

jQuery(function() {
  //$('#pc').text($('#firstswatch').text());
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    var optionValues = jQuery(this).attr('data-value');

    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');      
    if(optionValues == 'Color') {
      $('#pc').text(optionValue);
    }
  });
});

autoPlayYouTubeModal();
function autoPlayYouTubeModal() {	    	
  var trigger = $("body").find('[data-toggle="modal"]');
  trigger.click(function () {
    //$('.snow').show();
    var theModal = $(this).data("target"),
        videoSRC = $(this).attr("data-theVideo"),
        videoSRCauto = videoSRC + "?autoplay=1";
    $(theModal + ' iframe').attr('src', videoSRCauto);
    $(theModal + ' button.close').click(function () {
      //$('.snow').hide();
      $(theModal + ' iframe').attr('src', videoSRC);
    });
    $('.modal').click(function () {
      $(theModal + ' iframe').attr('src', videoSRC);
    });
  });
}
$(document).ready(function() {
  // Add a click event handler to the .wp-elementor-button-link element
  $('.wp-elementor-button-link').click(function(e) {
      e.preventDefault();
      $('.forkit').click();
  });
});